import { render, staticRenderFns } from "./PurchasesTableSettings.vue?vue&type=template&id=0ac5ab26&scoped=true"
import script from "./PurchasesTableSettings.vue?vue&type=script&lang=js"
export * from "./PurchasesTableSettings.vue?vue&type=script&lang=js"
import style0 from "./PurchasesTableSettings.vue?vue&type=style&index=0&id=0ac5ab26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac5ab26",
  null
  
)

export default component.exports